module.exports = __webpack_public_path__ + "f08db521b5bccd7ca4e71cba4831c4d3.pdf";